// Front-end errors + Core Web Vitals to the control plane (foundation spec "Observability"). The telemetry route is
// not in the control-plane spec yet (design.md): events are buffered (max 50) and dropped — never sent to a SaaS.
import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from 'web-vitals';

interface TelemetryEvent { kind: 'error' | 'vital'; at: string; release: string; app: string; route: string; tenant: string | null; data: unknown }
const buffer: TelemetryEvent[] = [];
let tenantSlug: string | null = null;
export function setTelemetryTenant(slug: string | null) { tenantSlug = slug; }
function push(kind: TelemetryEvent['kind'], data: unknown) {
  buffer.push({ kind, at: new Date().toISOString(), release: __RELEASE__, app: __APP__, route: window.location.pathname, tenant: tenantSlug, data });
  if (buffer.length > 50) buffer.shift();
}
export function reportError(err: unknown, info?: unknown) {
  const e = err instanceof Error ? { name: err.name, message: err.message, stack: err.stack?.slice(0, 2000) } : { message: String(err) };
  push('error', { ...e, info });
}
export function startVitals() {
  const rec = (m: Metric) => push('vital', { name: m.name, value: m.value, rating: m.rating });
  onCLS(rec); onINP(rec); onLCP(rec); onFCP(rec); onTTFB(rec);
  window.addEventListener('error', (e) => reportError(e.error ?? e.message));
  window.addEventListener('unhandledrejection', (e) => reportError(e.reason));
}
export function telemetryBuffer(): readonly TelemetryEvent[] { return buffer; }
